import { LESS_984_MEDIA_QUERY, LESS_620_MEDIA_QUERY } from '../../../../consts/adaptive';

export const styles = {
    container: {
        height: 120,
        padding: [0, 33],
        marginBottom: 30,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: '#F6F6F6',
        borderRadius: 8,
    },
    leftInner: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',

        '& > .no_reviews_img': {
            marginRight: 60,
        },

        '& > .not_found_img': {
            marginRight: 25,
        },

        '& > .error_img': {
            marginRight: 7,
        },
    },
    textWrapper: {
        display: 'flex',
        color: '#313140',
        width: '100%',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    messageTitle: {
        margin: 0,
        padding: 0,
        fontWeight: 600,
        fontSize: '18px',
    },
    messageText: {
        padding: 0,
        margin: [5, 0],
        fontWeight: 400,
        fontSize: '18px',
    },
    button: {
        width: 170,
        height: 34,
        background: '#FFD600',
        borderRadius: 4,
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
        color: '#313140',
        border: 'none',
        cursor: 'pointer',
        whiteSpace: 'nowrap',

        ['&:hover']: {
            backgroundColor: '#ffe352',
        },
    },
    [LESS_984_MEDIA_QUERY]: {
        container: {
            padding: [21, 28],
            flexDirection: 'column',
            height: 'fit-content',
        },
        leftInner: {
            marginBottom: 16,
            alignItems: 'flex-start',
            alignSelf: 'flex-start',
        },
        messageTitle: {
            marginBottom: 11,
            maxWidth: 330,
        },
        textWrapper: {
            flexDirection: 'column',
            alignItems: 'flex-start'
        },
        button: {
            marginTop: 10
        },
    },
    [LESS_620_MEDIA_QUERY]: {
        container: {
            padding: [20, 11],
            margin: [0, 10, 30],
        },
        leftInner: {
            display: 'block',

            '& > img': {
                marginTop: 20,
                marginRight: 15,
                float: 'left',
            },

            '& > .no_reviews_img': {
                marginTop: 0,
                marginRight: 15,
            },
        },
        textWrapper: {
            display: 'block',
        },
        messageTitle: {
            paddingTop: 20,
        },
        messageText: {
            clear: 'both',
            paddingTop: 15,
        },
        button: {
            width: '100%',
            marginLeft: 0,
        },
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
